import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@sourceflow/team.json";

export const useTeam = () =>
  useSourceFlowCollection(data).map((i) => ({ ...i, href: `/about-us/meet-team/${i.url_slug}` }));

export default useTeam;
